<template>
    <div v-if="formInput.visibility" class="position-relative row mb-3">
        <label class="form-label col-sm-2 col-form-label" :for="formInput.name">{{formInput.label}}</label>
        <div class="col-sm-10">
            <pv-auto-complete
                    :id="formInput.name"
                    class="form-control"
                    :class="{'is-invalid': formInput.error, 'is-valid': formInput.validated}"
                    :disabled="formInput.disabled"
                    v-tooltip.top="formInput.tooltip"
                    v-model="value"
                    :suggestions="filtered"
                    :delay="formInput.delay"
                    :field="formInput.field"
                    :minLength="formInput.minLength"
                    @complete="search($event)"
                    :forceSelection="formInput.forceSelection"
            />
            <div v-if="formInput.error" class="invalid-feedback">
                <span v-if="formInput.errorCustom">{{formInput.customMessage}}</span>
                <span v-if="formInput.errorRequired">{{formInput.requiredMessage}}</span>
            </div>
            <small class="form-text text-muted" v-if="formInput.info">
                {{formInput.info}}
            </small>
        </div>
    </div>
</template>

<script>

    import AutoComplete from 'primevue/autocomplete';
    import Tooltip from 'primevue/tooltip';


    export default {
        props: ['formInput'],
        emits: ['changeValue'],
        components: {
            'pv-auto-complete': AutoComplete,
        },
        directives: {
            'tooltip': Tooltip
        },
        data() {
            return {
                value: '',
                filtered: null
            }
        },
        created() {
            this.value = this.formInput.value;
        },
        watch: {
            value(newValue) {
                if (this.formInput) {
                    this.$emit('changeValue', {name: this.formInput.name, value: newValue})
                }
            },
            formInput: {
                handler() {
                    this.value = this.formInput.value;
                },
                deep: true
            }
        },
        methods: {
            async search(event) {
                let query = event.query.trim();
                this.filtered = await this.$store.dispatch(this.formInput.autocomplete, query);
            }
        }
    }
</script>